import articles from './articles';
import templates from './templates';
import users from './users';

export default {
  articles,
  templates,
  users,
};